import axios from 'axios';
import { getIdToken } from "../../../services/authService";
import { setBucketList, setCalendarTodos } from "./buckets";
import { auth } from "../../../firebase-config";
const { v4: uuidv4 } = require('uuid');

// Cache for current user email to avoid repeated API calls
let cachedUserEmail = null;

// Helper function to get current user's email from Firebase
const getCurrentUserEmail = async () => {
  // Return cached email if available
  if (cachedUserEmail) {
    return cachedUserEmail;
  }

  try {
    // Get email from Firebase auth
    const user = auth.currentUser;
    if (user && user.email) {
      cachedUserEmail = user.email;
      console.log(`✅ Current user: ${cachedUserEmail}`);
      return cachedUserEmail;
    }
  } catch (error) {
    console.warn('Could not get user email from Firebase:', error);
  }

  return 'anonymous';
};

// Function to clear cached user email (call on logout)
export const clearUserEmailCache = () => {
  cachedUserEmail = null;
  console.log('🔄 User email cache cleared');
};

export const getSpreadsheetData = async () => {

  const userEmail = await getCurrentUserEmail();

  if (!navigator.onLine) {
    // If offline, read data from user-specific local storage
    const storedData = localStorage.getItem(`last-state_${userEmail}`);
    if (storedData) {
      console.log(`📦 Loaded offline data for user: ${userEmail}`);
      // Dispatch offline status event
      window.dispatchEvent(new CustomEvent('app-offline-mode', {
        detail: { message: '⚠️ Working offline - changes will sync when back online' }
      }));
      return { values: JSON.parse(storedData), id: "_Whiteboard_Buckets_537" };
    } else {
      console.warn('No offline data found for user:', userEmail);
      window.dispatchEvent(new CustomEvent('app-offline-mode', {
        detail: { message: '⚠️ Offline - No cached data available' }
      }));
      return { values: [], id: "_Whiteboard_Buckets_537" };
    }
  }
  try {
    console.log('🌐 Fetching spreadsheet data from server for user:', userEmail);


    // Get Firebase ID token for authentication
    const idToken = await getIdToken();
    if (!idToken) {
      throw new Error('No Firebase ID token available');
    }

    console.log('🔑 Sending ID token:', idToken.substring(0, 20) + '...');

    const { getOrRefreshAccessToken } = await import("../../../services/authService");
    const googleAccessToken = await getOrRefreshAccessToken();
    if (!googleAccessToken) {
      throw new Error('No Google access token available. Please log in again.');
    }
    console.log('🔑 Sending Google access token:', googleAccessToken.substring(0, 20) + '...');
    // Make direct axios call to Cloud Run with credentials and log headers
    // Send both tokens in Authorization header (required format)
    const response = await axios.get(process.env.REACT_APP_PROD_SERVER_HOST + '/sheets/data', {
      headers: {
        'Authorization': `Bearer ${idToken}::GAT::${googleAccessToken}`,
        'Content-Type': 'application/json'
      },
      withCredentials: true
    });

    console.log('📤 Request headers sent:', {
      'Authorization': `Bearer ${idToken.substring(0, 20)}...`,
      'Content-Type': 'application/json'
    });

    const data = { values: response.data.data, id: "_Whiteboard_Buckets_537" };

    // Save the fetched data to user-specific local storage
    localStorage.setItem(`last-state_${userEmail}`, JSON.stringify(data.values));
    console.log(`✅ Cached data for user: ${userEmail}`);

    return data
  } catch (error) {
    console.error('Error fetching spreadsheet data', error);
  }
};

export const showCurrentTimes = (lucketTime) => {
  if (Object.keys(lucketTime).length == 0) {
    return "T"
  }

  let times = ""

  if (lucketTime.LN) {
    times = times + "LN" + " "
  }
  if (lucketTime.DN) {
    times = times + "DN" + " "
  }
  if (lucketTime.EM) {
    times = times + "EM" + " "
  }
  if (lucketTime.MO) {
    times = times + "MO" + " "
  }
  if (lucketTime.NO) {
    times = times + "NO" + " "
  }
  if (lucketTime.AF) {
    times = times + "AF" + " "
  }
  if (lucketTime.EV) {
    times = times + "EV" + " "
  }
  if (lucketTime.NI) {
    times = times + "NI" + " "
  }
  return times
}
export async function updateBucket(newValues, dispatch, buckets) {
  const userEmail = await getCurrentUserEmail();
  ;
  // Update local state immediately
  // const updatedBuckets = buckets.map(bucket => {
  //   if (bucket.rowID === newValues.rowID) {
  //     let newValues1 = newValues;
  //     if (typeof newValues1.time === "string") {
  //       newValues1.time = JSON.parse(newValues1.time);
  //     }
  //     if (typeof newValues1.fontSizeAndStyle === "string") {
  //       newValues1.fontSizeAndStyle = JSON.parse(newValues1.fontSizeAndStyle);
  //     }
  //     return newValues1;
  //   }
  //   return bucket;
  // })
  await axios.post(process.env.REACT_APP_PROD_SERVER_HOST + '/sheets/update-bucket', {
    newValues,
  }, {
    withCredentials: true,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('firebaseIdToken')}::GAT::${localStorage.getItem('googleAccessToken')}`,
      'Content-Type': 'application/json'
    }
  })

  try {
    const data = await getSpreadsheetData();
    const values = data.values;

    dispatch(setBucketList(values));
  } catch (error) {
    console.error('Error fetching spreadsheet data', error);
  }

  // const offlineChanges = JSON.parse(localStorage.getItem(`offline-changes_${userEmail}`) || '[]');
  // offlineChanges.push({ type: 'update', bucket: newValues });
  // localStorage.setItem(`offline-changes_${userEmail}`, JSON.stringify(offlineChanges));
}


export function updateValues(lucket, nameOfValue, newValue, fontStyleName) {

  let newLucket = { ...lucket };
  if (nameOfValue === "time") {
    newLucket.time = JSON.parse(newValue)
  }
  if (nameOfValue === "fontSizeAndStyle") {
    newLucket = {
      ...newLucket,

      "fontSizeAndStyle": { ...newLucket.fontSizeAndStyle, [fontStyleName]: newValue }

    };
  }
  else if (nameOfValue !== "time" && nameOfValue !== "fontSizeAndStyle") {
    newLucket[nameOfValue] = newValue;
  }

  return newLucket
}

export function getCurrentDateFromLuckets(buckets) {
  let maximum;
  buckets.forEach((l) => {
    if (!maximum) {
      maximum = l.date
    }
    else if ((new Date(maximum)) < (new Date(l.date))) {
      maximum = l.date
    }
  })
  return maximum
}

/**
 * Syncs all offline changes to the server when back online
 */
export async function syncOfflineChanges(dispatch) {
  const userEmail = await getCurrentUserEmail();

  const offlineChanges = JSON.parse(localStorage.getItem(`offline-changes_${userEmail}`) || '[]');

  if (offlineChanges.length === 0) {
    console.log('No offline changes to sync');
    return { success: true, synced: 0 };
  }

  console.log(`🔄 Syncing ${offlineChanges.length} offline changes...`);

  let successCount = 0;
  let failedChanges = [];

  for (const change of offlineChanges) {
    try {
      if (change.type === 'create') {
        // Sync created bucket
        const bucket = change.bucket;
        const response = await axios.post(process.env.REACT_APP_PROD_SERVER_HOST + '/sheets/add-bucket', {
          name: bucket.name,
          order: bucket.order,
          category: bucket.category,
          description: bucket.description,
          status: bucket.status,
          actionStatus: bucket.actionStatus,
          points: bucket.points,
          date: bucket.date,
          time: JSON.stringify(bucket.time),
          icon: bucket.icon,
          weekActionStatus: bucket.weekActionStatus,
          weekPoints: bucket.weekPoints,
          rowID: null,
          uniqueId: bucket.rowID,
          difficulty: bucket.difficulty,
          fontSizeAndStyle: JSON.stringify(bucket.fontSizeAndStyle),

        },
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${localStorage.getItem('firebaseIdToken')}::GAT::${localStorage.getItem('googleAccessToken')}`,
              'Content-Type': 'application/json'
            }
          });

        if (response.status === 200) {
          successCount++;
          console.log(`✅ Synced created bucket: ${bucket.name}`);
        } else {
          failedChanges.push(change);
          console.error(`❌ Failed to sync created bucket: ${bucket.name}`);
        }
      } else if (change.type === 'update') {
        // Sync updated bucket
        const bucket = change.bucket;
        const response = await axios.post(process.env.REACT_APP_PROD_SERVER_HOST + '/sheets/update-bucket', {
          newValues: bucket
        }, {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('firebaseIdToken')}::GAT::${localStorage.getItem('googleAccessToken')}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.status === 200) {
          successCount++;
          console.log(`✅ Synced updated bucket: ${bucket.name}`);
        } else {
          failedChanges.push(change);
          console.error(`❌ Failed to sync updated bucket: ${bucket.name}`);
        }
      }
    } catch (error) {
      console.error(`❌ Error syncing change:`, error);
      failedChanges.push(change);
    }
  }

  // Update offline changes - keep only failed ones
  if (failedChanges.length === 0) {
    localStorage.removeItem(`offline-changes_${userEmail}`);
    localStorage.removeItem(`pending-sync_${userEmail}`);
    console.log(`✅ All ${successCount} changes synced successfully`);
  } else {
    localStorage.setItem(`offline-changes_${userEmail}`, JSON.stringify(failedChanges));
    console.log(`⚠️ ${successCount} synced, ${failedChanges.length} failed`);
  }

  // Fetch fresh data from server after sync
  if (successCount > 0) {
    console.log('🔄 Fetching fresh data from server...');
    const result = await getSpreadsheetData();
    if (result && result.values) {
      // Remove offline flags from synced buckets
      const cleanedData = result.values.map(bucket => {
        const { _offlineCreated, _needsSync, ...cleanBucket } = bucket;
        return cleanBucket;
      });
      console.log('✅ Dispatching cleaned data to Redux:', cleanedData.length, 'buckets');
      dispatch(setBucketList(cleanedData));
      localStorage.setItem(`last-state_${userEmail}`, JSON.stringify(cleanedData));
    }
  }

  return {
    success: failedChanges.length === 0,
    synced: successCount,
    failed: failedChanges.length
  };
}

export async function addChildToLucket(lucket, childLuckets, luckets) {
  const userEmail = await getCurrentUserEmail();
  const uniqueId = uuidv4();

  // Calculate order for the child: number of existing children + 1
  const childOrder = childLuckets.length > 0 ? String(childLuckets.length + 1) : '1';

  // Generate random 5-digit number for name
  const randomNumber = Math.floor(10000 + Math.random() * 90000);

  // Create the child bucket object with parent's properties
  const childBucket = {
    name: `new${randomNumber}`,
    order: childOrder,
    category: lucket.category,
    description: "Wether you feel under control, if i am calm I can think what to do , if im not sleepy/drunk/disorganized.",
    status: "white",
    actionStatus: "white",
    points: 1,
    date: lucket.date,
    time: {},
    icon: "A1-Mind.svg",
    weekActionStatus: "white",
    weekPoints: 1,
    parentRowID: lucket.rowID, // Set parent ID
    rowID: uniqueId
  };

  // Check if offline
  if (!navigator.onLine) {
    console.log('⚠️ Offline - Child bucket added locally only');

    // Mark as offline-created and needs sync
    childBucket._offlineCreated = true;
    childBucket._needsSync = true;

    // Add child bucket to local state
    const updatedBuckets = [...luckets, childBucket];
    localStorage.setItem(`last-state_${userEmail}`, JSON.stringify(updatedBuckets));
    localStorage.setItem(`pending-sync_${userEmail}`, 'true');

    // Track this specific bucket as needing sync
    const offlineChanges = JSON.parse(localStorage.getItem(`offline-changes_${userEmail}`) || '[]');
    offlineChanges.push({ type: 'create', bucket: childBucket });
    localStorage.setItem(`offline-changes_${userEmail}`, JSON.stringify(offlineChanges));

    window.dispatchEvent(new CustomEvent('app-offline-mode', {
      detail: { message: '⚠️ Child bucket added offline - will sync when back online' }
    }));

    return { data: updatedBuckets, offline: true };
  }

  try {
    const response = await axios.post(process.env.REACT_APP_PROD_SERVER_HOST + '/sheets/add-child-lucket', {
      lucket,
      childLuckets,
      luckets,
    },
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('firebaseIdToken')}::GAT::${localStorage.getItem('googleAccessToken')}`,
          'Content-Type': 'application/json'
        }
      }
    );

    const result = response.data;
    if (response.status === 200) {
      console.log(result.message);
    } else {
      console.error('Error:', result.message);
    }

    return result;
  } catch (error) {
    console.error('Network error while adding child lucket:', error);

    // If network error, save locally
    console.log('⚠️ Network error - Child bucket added locally only');

    // Mark as offline-created and needs sync
    childBucket._offlineCreated = true;
    childBucket._needsSync = true;

    const updatedBuckets = [...luckets, childBucket];
    localStorage.setItem(`last-state_${userEmail}`, JSON.stringify(updatedBuckets));
    localStorage.setItem(`pending-sync_${userEmail}`, 'true');

    // Track this specific bucket as needing sync
    const offlineChanges = JSON.parse(localStorage.getItem(`offline-changes_${userEmail}`) || '[]');
    offlineChanges.push({ type: 'create', bucket: childBucket });
    localStorage.setItem(`offline-changes_${userEmail}`, JSON.stringify(offlineChanges));

    return { data: updatedBuckets, offline: true };
  }
}

export async function addBucketToSpreadsheet(newBucketName, newBucketOrder, newBucketCategory, parentLucket, currentDate) {
  const userEmail = await getCurrentUserEmail();
  const uniqueId = uuidv4();

  // Get current buckets to calculate order
  const storedData = localStorage.getItem(`last-state_${userEmail}`);
  const currentBuckets = storedData ? JSON.parse(storedData) : [];

  // Calculate default order: find highest order in the same category + 1
  const targetCategory = newBucketCategory || 'A';
  const bucketsInCategory = currentBuckets.filter(b => b.category === targetCategory);
  const defaultOrder = bucketsInCategory.length > 0
    ? String(bucketsInCategory.length + 1)
    : '1';

  // Create the new bucket object
  const newBucket = {
    name: newBucketName,
    order: newBucketOrder || defaultOrder, // Default to end of category
    category: targetCategory, // Default to Category A
    description: "Wether you feel under control, if i am calm I can think what to do , if im not sleepy/drunk/disorganized.",
    status: "white",
    actionStatus: "white",
    points: 1,
    date: currentDate,
    time: {},
    icon: "A1-Mind.svg",
    weekActionStatus: "white",
    weekPoints: 1,
    parentRowID: parentLucket ? parentLucket.rowID : "", // Use empty string to match server format
    rowID: uniqueId
  };

  // Check if offline
  if (!navigator.onLine) {
    console.log('⚠️ Offline - Bucket added locally only');

    // Get current buckets from localStorage
    const storedData = localStorage.getItem(`last-state_${userEmail}`);
    const currentBuckets = storedData ? JSON.parse(storedData) : [];

    // Mark as offline-created and needs sync
    newBucket._offlineCreated = true;
    newBucket._needsSync = true;

    // Add new bucket to local state
    const updatedBuckets = [...currentBuckets, newBucket];
    localStorage.setItem(`last-state_${userEmail}`, JSON.stringify(updatedBuckets));
    localStorage.setItem(`pending-sync_${userEmail}`, 'true');

    // Track this specific bucket as needing sync
    const offlineChanges = JSON.parse(localStorage.getItem(`offline-changes_${userEmail}`) || '[]');
    offlineChanges.push({ type: 'create', bucket: newBucket });
    localStorage.setItem(`offline-changes_${userEmail}`, JSON.stringify(offlineChanges));

    return { data: updatedBuckets, offline: true };
  }

  try {
    const response = await axios.post(process.env.REACT_APP_PROD_SERVER_HOST + '/sheets/add-bucket', {
      name: newBucketName,
      order: newBucketOrder || defaultOrder,
      category: newBucketCategory || targetCategory,
      description: "Wether you feel under control, if i am calm I can think what to do , if im not sleepy/drunk/disorganized.",
      status: "white",
      actionStatus: "white",
      points: 1,
      date: currentDate,
      time: JSON.stringify({}),
      icon: "A1-Mind.svg",
      weekActionStatus: "white",
      weekPoints: 1,
      rowID: null,
      uniqueId
    },
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('firebaseIdToken')}::GAT::${localStorage.getItem('googleAccessToken')}`,
          'Content-Type': 'application/json'
        }
      });

    const result = response.data;

    if (response.status === 200) {
      // Save to localStorage after successful server sync
      localStorage.setItem(`last-state_${userEmail}`, JSON.stringify(result.data));
    }
    return result
  } catch (error) {
    console.error('Error adding bucket to spreadsheet:', error);

    // If network error, save locally
    console.log('⚠️ Network error - Bucket added locally only');
    const storedData = localStorage.getItem(`last-state_${userEmail}`);
    const currentBuckets = storedData ? JSON.parse(storedData) : [];

    // Mark as offline-created and needs sync
    newBucket._offlineCreated = true;
    newBucket._needsSync = true;

    const updatedBuckets = [...currentBuckets, newBucket];
    localStorage.setItem(`last-state_${userEmail}`, JSON.stringify(updatedBuckets));
    localStorage.setItem(`pending-sync_${userEmail}`, 'true');

    // Track this specific bucket as needing sync
    const offlineChanges = JSON.parse(localStorage.getItem(`offline-changes_${userEmail}`) || '[]');
    offlineChanges.push({ type: 'create', bucket: newBucket });
    localStorage.setItem(`offline-changes_${userEmail}`, JSON.stringify(offlineChanges));

    return { data: updatedBuckets, offline: true };
  }
}

export const handleLucketDelete = async (lucket) => {
  console.log('Lucket spreadsheet row ID:', lucket.rowID + 1);

  try {
    const response = await axios.post(process.env.REACT_APP_PROD_SERVER_HOST + '/sheets/delete-bucket', {
      rowID: lucket.rowID
    },
      {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('firebaseIdToken')}::GAT::${localStorage.getItem('googleAccessToken')}`,
          'Content-Type': 'application/json'
        }
      });
    let data = response.data;
    console.log(data, 'response.data')
    if (response.status === 200) {
      console.log('Item successfully deleted from Google Sheets');
    } else {
      console.error('Error deleting item:', data.message);
    }
    return data
  } catch (error) {
    console.error('Failed to connect to server:', error.message);
  }

};


